__turbopack_context__.v({
  "image": "product-image-module-scss-module__qQJWYG__image",
  "regular": "product-image-module-scss-module__qQJWYG__regular",
  "wide": "product-image-module-scss-module__qQJWYG__wide",
  "wideOnMobile": "product-image-module-scss-module__qQJWYG__wideOnMobile",
});
